import { useEffect } from 'react';

const SITE_URL = 'https://content-135.emergent.host';
const DEFAULT_OG = `${SITE_URL}/k-root-logo.png`;

const setMeta = (selector, attr, value) => {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const parts = selector.match(/\[(name|property)="([^"]+)"\]/);
    if (parts) el.setAttribute(parts[1], parts[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

/**
 * SEO helper that updates the document head per route.
 * Usage: <SEO title="..." description="..." path="/products/..." image="..." />
 */
const SEO = ({
  title,
  description,
  image = DEFAULT_OG,
  path = typeof window !== 'undefined' ? window.location.pathname : '/',
  type = 'website',
  noIndex = false,
}) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | K-Root` : 'K-Root — Korean Scalp Revival Bar | Less Shedding. More Hair.';
    document.title = fullTitle;

    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[name="robots"]', 'content', noIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');

    // Open Graph
    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:type"]', 'content', type);
    setMeta('meta[property="og:url"]', 'content', `${SITE_URL}${path}`);
    setMeta('meta[property="og:image"]', 'content', image);

    // Twitter
    setMeta('meta[name="twitter:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:image"]', 'content', image);
    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');

    setCanonical(`${SITE_URL}${path}`);
  }, [title, description, image, path, type, noIndex]);

  return null;
};

export default SEO;
